import { Link } from "react-router-dom";

type BBAAccountProps = {
  address: string;
  label?: string;
  link?: boolean;
};
function BBAAccount({ address, label, link }: BBAAccountProps) {
  if (link) {
    return (
      <Link
        to={`/address/${address}`}
        className="text-small truncate text-green-900"
      >
        {label ?? address}
      </Link>
    );
  }

  return (
    <p className="text-small truncate text-green-900">{label ?? address}</p>
  );
}

export default BBAAccount;
